export interface AlainImageConfig {
  /**
   * é»è®¤å¤§å°ï¼é»è®¤å¼ï¼`64`ï¼åä½ï¼px
   */
  size?: number;

  /**
   * éè¯¯å¾çï¼é»è®¤ï¼`./assets/img/logo.svg`
   */
  error?: string;
}
